import React, { useState } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { requestForgotPassword } from "../../../actions/auth";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLoading } from "../../../components/LoadingContext";
import SuccessModal from "./_components/SuccessModal";
import { CheckRoundedIcon, ArrowRightIcon } from "../../../components/icons";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true); // Initially set to true to avoid initial error display
  const [emailError, setEmailError] = useState("");
  const [error, setError] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const { showLoading, closeLoading } = useLoading();
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  const history = useHistory();

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    setEmail(emailValue);
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    setIsValidEmail(isValid);
    // Set error message based on validation result
    setEmailError(isValid ? "" : "Please enter a valid email address");
  };

  const handleResetPassword = async () => {
    showLoading(true);
    if (isValidEmail) {
      const requestForgotPasswordResponse = await requestForgotPassword(
        email,
        lang
      );
      if (requestForgotPasswordResponse.code === 201) {
        setEmailSent(true);
        // setShowModalSuccess(true);
      } else {
        setEmailError("Please enter a valid email address");
      }
    } else {
      setEmailError("Please enter a valid email address");
    }
    closeLoading(true);
  };

  return (
    <FrontLayout>
      <div className="custom-mx tw:mt-4 tw:pt-4 tw:sm:mt-12 tw:sm:pt-12">
        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:md:pb-0 tw:pt-12 tw:md:pt-0 custom-mt-6 tw:lg:w-full tw:lg:flex-none">
          <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:pb-12 tw:lg:justify-center">
            <div className="tw:w-full tw:flex-none tw:md:w-[83.3333%] tw:md:flex-none tw:px-12 tw:py-12">
              <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-12">
                {emailSent ? (
                  <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px]">
                    <div className="tw:text-center tw:mb-6">
                      <CheckRoundedIcon />
                    </div>
                    <h2 className="tw:text-center tw:my-6">
                      {t("forget_password.success_title")}
                    </h2>
                    <p
                      className="tw:text-center"
                      dangerouslySetInnerHTML={{
                        __html: t("forget_password.success_body", {
                          email: email,
                        }),
                      }}
                    ></p>
                    <div className="tw:mt-12">
                      <div className="tw:flex tw:justify-center tw:items-center tw:gap-6">
                        <p className="tw:m-0 tw:p-0">
                          {t("forget_password.email_not_received")}
                        </p>
                        <button
                          type="button"
                          onClick={handleResetPassword}
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-outline-primary tw:px-12 tw:rounded-[0.5rem]"
                        >
                          {t("forget_password.resend_email_button")}
                        </button>
                      </div>
                    </div>
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                      <button
                        type="button"
                        className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:text-sm tw:py-1 tw:px-2 tw:rounded-[0.5rem] tw:w-1/3 tw:flex-none tw:md:ml-[33.3333%] tw:grid tw:py-2 fs-14 tw:mt-12"
                        onClick={() => history.push("/")}
                      >
                        <div className="tw:flex tw:items-center tw:justify-center tw:px-2">
                          {t("forget_password.back_to_home")}
                          <i className="tw:pl-2">
                            <ArrowRightIcon color="#4A4A4A" size={24} />
                          </i>
                        </div>
                      </button>

                      <p
                        className="tw:text-center tw:mt-12"
                        dangerouslySetInnerHTML={{
                          __html: t("forget_password.success_footer"),
                        }}
                      ></p>
                    </div>
                  </div>
                ) : (
                  <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-1/2 tw:md:flex-none tw:md:ml-[25%]">
                    {error && <div
                      className="alert alert-danger"
                      role="alert"
                    >
                      {error}
                    </div>
                    }
                    <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]">
                      <div className="tw:flex-1 tw:p-4">
                        <h5 className="tw:mb-4">{t("ForgotPasswordPage.Title")}</h5>
                        <div
                          className={`tw:relative tw:mb-4 ${isValidEmail ? "" : "has-danger"
                            }`}
                        >
                          <input
                            type="email"
                            className={`tw:peer tw:block tw:w-full tw:h-[calc(3.5rem+2px)] tw:leading-[1.25] tw:text-[14px] tw:text-[#4e4e4e] tw:bg-white tw:border tw:border-[#f1f1f1] tw:rounded-[0.3rem] tw:pt-[1.625rem] tw:pb-[0.625rem] tw:pr-3 tw:pl-[1.1rem] tw:placeholder-transparent tw:[font-family:var(--font-sans-primary)] tw:focus:border-[#c9c9c9] tw:focus:outline-none tw:focus:shadow-[0_0_0_0.25rem_rgba(13,110,253,0.25)] tw:disabled:bg-[rgba(167,167,167,0.1)] ${isValidEmail ? "" : "invalid "
                              }`}
                            id="floatingInput"
                            placeholder="name@example.com"
                            value={email}
                            onChange={handleEmailChange}
                            required
                          />
                          <label htmlFor="floatingInput" className="tw:absolute tw:top-0 tw:left-0 tw:h-full tw:pl-4 tw:pt-4 tw:pr-3 tw:pointer-events-none tw:text-[14px] tw:text-[#a7a7a7] tw:[font-family:var(--font-sans-primary)] tw:origin-[0_0] tw:transition-[opacity,transform] tw:duration-100 tw:ease-in-out tw:scale-[0.85] tw:-translate-y-2 tw:translate-x-[0.15rem] tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:translate-x-0 tw:peer-focus:scale-[0.85] tw:peer-focus:-translate-y-2 tw:peer-focus:translate-x-[0.15rem]">{t("Email.Address")}</label>

                          {emailError !== "" && (
                            <p className="tw:text-[#dc3545]!">{emailError}</p>
                          )}
                        </div>
                        <div className="tw:grid">
                          <button
                            className={`tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:py-2 ${isValidEmail && email !== "" ? "" : "disabled"
                              }`}
                            onClick={handleResetPassword}
                            disabled={!isValidEmail}
                          >
                            Reset Password
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showModalSuccess}
        handleClose={() => history.push("/")}
        successMessage={"The password reset link has been sent to user@gmail.com"}
      />
    </FrontLayout>
  );
};

export default ForgotPassword;
